import React, { useEffect, useState } from "react";
import "./submitArticle.css";
import Form from "./form";
import getCategoryService from "../../../services/getCategoryService";
import Loader from "../../../commonComponents/loader";
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Alert,
  Snackbar,
  Divider,
  Card,
  CardContent,
  Stepper,
  Step,
  StepLabel,
  IconButton,
  Tooltip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getCookie } from "../../../function";
import { API_URL } from "../../../config";
import axios from "axios";
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Info as InfoIcon,
} from "@mui/icons-material";
import getArticleService from "../../../services/getArticleService";

const SubmitArticle = () => {
  const [getCategoryData, setGetCategoryData] = useState([]);
  const [loadingCheck, setLoadingCheck] = useState(false);
  const [title, setTitle] = useState("");
  const [authorName, setAuthorName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [gstNumber, setGstNumber] = useState("");
  const [journalName, setJournalName] = useState("");
  const [publicationType, setPublicationType] = useState("");
  const [serviceType, setServiceType] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [totalFees, setTotalFees] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [paymentProof, setPaymentProof] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [journalList, setJournalList] = useState([]);

  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const list = await getCategoryService.GetAllCategoryList();

      setGetCategoryData(list); // Set the data to state
      setJournalList(list.filter((item) => item.category === "Journal"));
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    fetchData(); // Call fetchData initially when the component mounts
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  };

  const handlePaymentProofChange = (e) => {
    const file = e.target.files[0];
    setPaymentProof(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("title", title);
      formData.append("authorName", authorName);
      formData.append("email", email);
      formData.append("phoneNumber", phoneNumber);
      formData.append("gstNumber", gstNumber);
      formData.append("journalName", journalName);
      formData.append("publicationType", publicationType);
      formData.append("serviceType", serviceType);
      formData.append("totalFees", totalFees);
      formData.append("paymentMode", paymentMode);
      formData.append("selectedFile", selectedFile);
      formData.append("paymentProof", paymentProof);

      const response = await axios.post(
        `${API_URL}/articles/submit`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${getCookie("token")}`,
          },
        }
      );

      if (response.data.success) {
        setSnackbarSeverity("success");
        setSnackbarMessage("Invoice submitted successfully!");
        setOpenSnackbar(true);
        navigate("/client/articleList");
      } else {
        setSnackbarSeverity("error");
        setSnackbarMessage("Failed to submit Invoice.");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Error submitting Invoice:", error);
      setSnackbarSeverity("error");
      setSnackbarMessage("An error occurred. Please try again later.");
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        p: { xs: 2, md: 4 },
        maxWidth: "1200px",
        margin: "0 auto",
        minHeight: "100vh",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: { xs: 2, md: 4 },
          borderRadius: 2,
          backgroundColor: "background.paper",
          boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Box sx={{ mb: 4 }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "primary.main",
              mb: 1,
            }}
          >
            Submit Invoice
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Please fill in the details below to submit your Invoice for review.
          </Typography>
        </Box>

        {loadingCheck ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "200px",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Form
            getCategoryData={getCategoryData}
            setLoadingCheck={setLoadingCheck}
          />
        )}
      </Paper>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default SubmitArticle;
